import React, { useState } from 'react';

import { ArrowLeftOutlined } from '@ant-design/icons';
import { SalesOrderLineDTO } from '@recurrency/core-api-schema/dist/salesOrderLines/getSalesOrderLines';
import { theme } from 'theme';

import { Button } from 'components/Button';
import { Modal } from 'components/Modal';
import { OrderAssemblyLinesTable } from 'components/recipes/OrderAssemblyLinesTable';
import { Typography } from 'components/Typography';

export function OrderAssemblyLinesModal({
  itemId,
  orderLineUid,
  orderLines,
  onClose,
}: {
  itemId: string;
  orderLineUid: string;
  orderLines: SalesOrderLineDTO[];
  onClose: () => void;
}) {
  // Use state to store an array of objects, each containing the previous values of the current itemID and currentOrderLineUid
  const [previousItemIdAndOrderLineUid, setPreviousItemIdAndOrderLineUid] = useState<
    { itemId: string; orderLineUid: string }[]
  >([]);

  const [currentItemId, setCurrentItemId] = useState(itemId);
  const [currentOrderLineUid, setCurrentOrderLineUid] = useState(orderLineUid);

  const handleClick = (clickedItemId: string, clickedOrderLineUid: string) => {
    setPreviousItemIdAndOrderLineUid([
      ...previousItemIdAndOrderLineUid,
      { itemId: currentItemId, orderLineUid: currentOrderLineUid },
    ]);
    setCurrentItemId(clickedItemId);
    setCurrentOrderLineUid(clickedOrderLineUid);
  };

  const handleBackClick = () => {
    const itemIdAndOrderLineUid = previousItemIdAndOrderLineUid.pop();
    setCurrentItemId(itemIdAndOrderLineUid?.itemId || '0');
    setCurrentOrderLineUid(itemIdAndOrderLineUid?.orderLineUid || '0');
  };

  return (
    <Modal
      destroyOnClose
      visible
      title={
        <>
          <Button
            size="small"
            type="link"
            onClick={currentItemId !== itemId && currentOrderLineUid ? handleBackClick : onClose}
            style={{ display: 'inline-block' }}
          >
            <ArrowLeftOutlined />
          </Button>
          <Typography style={{ display: 'inline-block', color: theme.colors.neutral[700] }}>ASSEMBLY: #</Typography>
          <Typography copyable style={{ display: 'inline-block', color: theme.colors.neutral[700] }}>
            {currentItemId}
          </Typography>
        </>
      }
      width={1200}
      onCancel={onClose}
      footer={
        <Button onClick={onClose} type="primary" size="small">
          Close
        </Button>
      }
    >
      <OrderAssemblyLinesTable orderLines={orderLines} orderLineUid={currentOrderLineUid} onClick={handleClick} />
    </Modal>
  );
}
